<template>
<ItpBox
  direction="column"
  alignItems="stretch"
  v-if="loaded"
>
  <ItpBox
    class="pb-2"
  >
    <strong>
      {{ 'Works'|pgettext('Worksheet') }}
    </strong>
  </ItpBox>
  <ItpDataTable
    rowKey="id"
    tableId="WorksheetWorkItems"
    :rowHeader="b_5962862420439144_rowHeader"
    :paging="b_5962862420439144_paging"
    :sortable="b_5962862420439144_sortable"
    :editable="!isReadonly"
    :value="worksheet.work_items"
    variant="details"
    :rowTemplate="{ worksheet_id: worksheet.id, task: null, service_id: null }"
    :columns="b_5962862420439144_columns"
    class="h-100"
    v-if="loaded"
    @save-completed="evh_5962862420439144_saveCompleted($event, {})"
    @save="evh_5962862420439144_save($event, {})"
    @delete="evh_5962862420439144_delete($event, {})"
    @service:selected="evh_5962862420439144_serviceSelected($event, {})"
    @service:change="evh_5962862420439144_serviceChange($event, {})"
    @quantity:change="evh_5962862420439144_quantityChange($event, {})"
    @unit_price:change="evh_5962862420439144_unitPriceChange($event, {})"
    @discount:change="evh_5962862420439144_discountChange($event, {})"
    @net_amount:change="evh_5962862420439144_netAmountChange($event, {})"
    @amount:change="evh_5962862420439144_amountChange($event, {})"
    @tax_code:change="evh_5962862420439144_taxCodeChange($event, {})"
  >
  </ItpDataTable>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcWorksheetWorkItems extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  onServiceSelected(...args: any[]) {
    const [row, service] = args;

    row.service = service
    row.service_id = service.id
    row.unit = service.unit;
    row.task = service.name
    row.tax_code = service.sales_vat_code;
    row.intermediated_service = service.intermediated_service || false;
    row.setFocus('quantity')
  }

  onServiceChanged(...args: any[]) {
    console.log('onServiceChanged', args)
  }

  calculateUnitPrice(...args: any[]) {
    const [row, tax, decimals] = args;

    row.unit_price = Big(
      Big(row.net_amount) / Big(row.quantity) / (1 - Big(row.discount) / 100)
    ).round(decimals).toNumber()
  }

  calculateNetAmount(...args: any[]) {
    const [row, tax, decimals] = args;

    row.net_amount = Big(
      Big(row.quantity) * Big(row.unit_price) * (1 - Big(row.discount) / 100)
    ).round(decimals).toNumber()
  }

  calculateNetAmountFromAmount(...args: any[]) {
    const [row, tax, decimals] = args;

    row.net_amount = Big(
      Big(row.amount) / (1 + Big(tax.rate) / 100)
    ).round(decimals).toNumber()
  }

  calculateAmount(...args: any[]) {
    const [row, tax, decimals] = args;

    row.amount = Big(
      Big(row.net_amount) * (1 + Big(tax.rate) / 100)
    ).round(decimals).toNumber()
  }

  recalculateLineItem(...args: any[]) {
    const data = args[0].data;
    const row = data.row;
    const decimals = 2;
    const tx = _.find(this.taxCodes, { id: row.tax_code });

    if (row.quantity === 0) {
      return;
    }

    switch (data.field) {
      case 'quantity':
      case 'unit_price':
      case 'discount': {
        this.calculateNetAmount(row, tx, decimals);
        this.calculateAmount(row, tx, decimals);
        break;
      }

      case 'net_amount': {
        this.calculateUnitPrice(row, tx, decimals);
        this.calculateAmount(row, tx, decimals);
        break;
      }

      case 'tax_code': {
        this.calculateAmount(row, tx, decimals);
        break;
      }

      case 'amount': {
        this.calculateNetAmountFromAmount(row, tx, decimals);
        this.calculateUnitPrice(row, tx, decimals);
        break;
      }
    }
  }

  @Prop({
    required: true,
    type: Object,
  })
  worksheet!: object;

  @Watch('worksheet')
  onWorksheet(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("worksheet")
  }

  @Prop({
    type: Boolean,
  })
  isReadonly!: boolean;

  @Watch('isReadonly')
  onIs_readonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("isReadonly")
  }

  expenseTypes!: any;

  async $$load_expenseTypes() {
    return this.$fn.fetch('list_object_by_type', { parameters: { object_type: 'expense-type' } })
  }

  taxCodes!: any;

  async $$load_taxCodes() {
    return this.$fn.fetch('list_tax_code')
  }

  units!: any;

  async $$load_units() {
    return this.$fn.fetch('list_unit')
  }

  ux!: any;
  b_5962862420439144_rowHeader!: any;
  b_5962862420439144_paging!: any;
  b_5962862420439144_sortable!: any;
  b_5962862420439144_columns!: any;

  async $$load_b_5962862420439144_columns() {
    return [{
      name: "service",
      type: "select2",
      header: this.$fn.gettext("Task"),
      width: "140px",
      formatter: {
        name: "template",
        value: "<b-link :to=\"{\n\
  name: 'app.product',\n\
  params: { id: row.service_id }\n\
}\">{{ row.task }}</b-link>\n\
",
      }
      ,
      options: this.$fn.searchDataSource('suggest_product', { parameters: { product_types: 'service' } }),
      optionValueField: "name",
      valueField: "id",
      textField: "name",
      bindObject: true,
      validator: ["required"
        ,
      ]
      ,
    }
      ,
    {
      name: "asset",
      type: "select2",
      header: this.$fn.gettext("Asset"),
      width: "140px",
      formatter: {
        name: "template",
        value: "<b-link :to=\"{\n\
  name: 'app.fixedAsset',\n\
  params: { id: row.asset_id }\n\
}\">{{ row.asset ? row.asset.name : '-' }}</b-link>\n\
",
      }
      ,
      options: this.$fn.searchDataSource('suggest_fixed_asset'),
      optionValueField: "name",
      valueField: "id",
      textField: "name",
      bindObject: true,
    }
      ,
    {
      name: "date",
      type: "date",
      header: this.$fn.gettext("Date"),
      width: "140px",
      required: true,
    }
      ,
    {
      name: "notes",
      type: "textarea",
      width: "200px",
      header: this.$fn.gettext("Notes"),
    }
      ,
    {
      name: "quantity",
      type: "number",
      default: 0,
      header: this.$fn.pgettext("Quantity Abbr", "Qty"),
      headerTooltip: this.$fn.gettext("Quantity"),
      width: "60px",
      textAlign: "right",
      required: true,
      editorIsDisabled: row => !row.service || !row.service.id,
    }
      ,
    {
      name: "unit",
      header: this.$fn.pgettext("Unit Abbr", "Unit"),
      headerTooltip: this.$fn.gettext("Unit"),
      width: "70px",
      textAlign: "center",
      required: true,
      editorIsDisabled: row => !row.service || !row.service.id,
    }
      ,
    {
      name: "unit_price",
      type: "number",
      default: 0,
      header: this.$fn.gettext("Price"),
      width: "70px",
      textAlign: "right",
      required: true,
      editorIsDisabled: row => !row.service || !row.service.id,
    }
      ,
    {
      name: "discount",
      type: "number",
      default: 0,
      header: this.$fn.pgettext("AbbrDiscount", "Disc"),
      headerTooltip: this.$fn.gettext("Discount"),
      width: "70px",
      required: true,
      editorIsDisabled: row => !row.service || !row.service.id,
    }
      ,
    {
      name: "net_amount",
      type: "number",
      default: 0,
      header: this.$fn.gettext("Net"),
      width: "100px",
      textAlign: "right",
      required: true,
      editorIsDisabled: row => !row.service || !row.service.id,
    }
      ,
    {
      name: "amount",
      type: "number",
      default: 0,
      header: this.$fn.gettext("Amount"),
      width: "100px",
      textAlign: "right",
      required: true,
      editorIsDisabled: row => !row.service || !row.service.id,
    }
      ,
    {
      name: "tax_code",
      header: this.$fn.gettext("VAT"),
      headerTooltip: this.$fn.gettext("VAT Code"),
      width: "100px",
      type: "select",
      options: this.taxCodes,
      valueField: "id",
      textField: "id",
      editorIsDisabled: row => !row.service || !row.service.id,
    }
      ,
    {
      name: "intermediated_service",
      header: this.$fn.pgettext("AbbrIntermediatedService", "IMS"),
      headerTooltip: this.$fn.gettext("Intermediated Service"),
      width: "60px",
      type: "checkbox",
      editorIsDisabled: row => !row.service || !row.service.id,
    }
      ,
    ]
  }

  dataMembers = ['expenseTypes', 'taxCodes', 'units', 'ux', 'b_5962862420439144_rowHeader', 'b_5962862420439144_paging', 'b_5962862420439144_sortable', 'b_5962862420439144_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        expenseTypes: null,
        taxCodes: null,
        units: null,
        ux: {
          errorHandling: "local",
          initialLoadSpinner: true,
        }
        ,
        b_5962862420439144_rowHeader: false,
        b_5962862420439144_paging: false,
        b_5962862420439144_sortable: false,
        b_5962862420439144_columns: null,
      },
    }
  }

  async act_5962862420439144_emit_8362_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5962862420439144_emit_8362, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_5962862420439144_saveCompleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_saveCompleted.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8364_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8364, alias=undefined
    this.worksheet.id
      ? $event.data.waitFor(this.$fn.crud('work_item').upsert({ ...$event.data.row, worksheet_id: this.worksheet.id }))
      : this.worksheet.work_items.splice(this.worksheet.work_items.length - 1, 0, $event.data.row)
  }

  async act_5962862420439144_script_8364_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8364, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8364_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_save.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8366_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8366, alias=undefined
    this.worksheet.id
      ? $event.data.waitFor(this.$fn.crud('work_item').delete($event.data.row))
      : _.remove(this.worksheet.work_items, $event.data.row)
  }

  async act_5962862420439144_script_8366_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8366, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8366_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_delete.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8368_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8368, alias=undefined
    this.onServiceSelected($event.data.row, $event.data.option)
  }

  async act_5962862420439144_script_8368_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8368, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8368_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_serviceSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_serviceSelected.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8370_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8370, alias=undefined
    this.onServiceChanged($event)
  }

  async act_5962862420439144_script_8370_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8370, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8370_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_serviceChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_serviceChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8372_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8372, alias=undefined
    this.recalculateLineItem($event)
  }

  async act_5962862420439144_script_8372_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8372, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8372_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_quantityChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_quantityChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8374_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8374, alias=undefined
    this.recalculateLineItem($event)
  }

  async act_5962862420439144_script_8374_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8374, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8374_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_unitPriceChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_unitPriceChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8376_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8376, alias=undefined
    this.recalculateLineItem($event)
  }

  async act_5962862420439144_script_8376_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8376, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8376_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_discountChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_discountChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8378_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8378, alias=undefined
    this.recalculateLineItem($event)
  }

  async act_5962862420439144_script_8378_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8378, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8378_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_netAmountChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_netAmountChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8380_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8380, alias=undefined
    this.recalculateLineItem($event)
  }

  async act_5962862420439144_script_8380_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8380, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8380_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_amountChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_amountChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8382_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8382, alias=undefined
    this.recalculateLineItem($event)
  }

  async act_5962862420439144_script_8382_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8382, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8382_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_taxCodeChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_taxCodeChange.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_5962862420439144_emit_8362: actions.EmitAction;
    evh_5962862420439144_saveCompleted_8361: actions.EventHandlerImpl;
    evh_5962862420439144_saveCompleted: actions.EventHandlerGroup;
    act_5962862420439144_script_8364: actions.ScriptAction;
    evh_5962862420439144_save_8363: actions.EventHandlerImpl;
    evh_5962862420439144_save: actions.EventHandlerGroup;
    act_5962862420439144_script_8366: actions.ScriptAction;
    evh_5962862420439144_delete_8365: actions.EventHandlerImpl;
    evh_5962862420439144_delete: actions.EventHandlerGroup;
    act_5962862420439144_script_8368: actions.ScriptAction;
    evh_5962862420439144_serviceSelected_8367: actions.EventHandlerImpl;
    evh_5962862420439144_serviceSelected: actions.EventHandlerGroup;
    act_5962862420439144_script_8370: actions.ScriptAction;
    evh_5962862420439144_serviceChange_8369: actions.EventHandlerImpl;
    evh_5962862420439144_serviceChange: actions.EventHandlerGroup;
    act_5962862420439144_script_8372: actions.ScriptAction;
    evh_5962862420439144_quantityChange_8371: actions.EventHandlerImpl;
    evh_5962862420439144_quantityChange: actions.EventHandlerGroup;
    act_5962862420439144_script_8374: actions.ScriptAction;
    evh_5962862420439144_unitPriceChange_8373: actions.EventHandlerImpl;
    evh_5962862420439144_unitPriceChange: actions.EventHandlerGroup;
    act_5962862420439144_script_8376: actions.ScriptAction;
    evh_5962862420439144_discountChange_8375: actions.EventHandlerImpl;
    evh_5962862420439144_discountChange: actions.EventHandlerGroup;
    act_5962862420439144_script_8378: actions.ScriptAction;
    evh_5962862420439144_netAmountChange_8377: actions.EventHandlerImpl;
    evh_5962862420439144_netAmountChange: actions.EventHandlerGroup;
    act_5962862420439144_script_8380: actions.ScriptAction;
    evh_5962862420439144_amountChange_8379: actions.EventHandlerImpl;
    evh_5962862420439144_amountChange: actions.EventHandlerGroup;
    act_5962862420439144_script_8382: actions.ScriptAction;
    evh_5962862420439144_taxCodeChange_8381: actions.EventHandlerImpl;
    evh_5962862420439144_taxCodeChange: actions.EventHandlerGroup;
  }

  getActions() {
    const act_5962862420439144_emit_8362 = new actions.EmitAction(
      {
        actionArgs: this.act_5962862420439144_emit_8362_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_saveCompleted_8361 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_emit_8362,
        event: "save-completed",
        displayName: "emit",
      }
    );
    const evh_5962862420439144_saveCompleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_saveCompleted_8361],
      }
    );
    const act_5962862420439144_script_8364 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8364_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_save_8363 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8364,
        event: "save",
        displayName: "script",
      }
    );
    const evh_5962862420439144_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_save_8363],
      }
    );
    const act_5962862420439144_script_8366 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8366_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_delete_8365 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8366,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_5962862420439144_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_delete_8365],
      }
    );
    const act_5962862420439144_script_8368 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8368_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_serviceSelected_8367 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8368,
        event: "service:selected",
        displayName: "script",
      }
    );
    const evh_5962862420439144_serviceSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_serviceSelected_8367],
      }
    );
    const act_5962862420439144_script_8370 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8370_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_serviceChange_8369 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8370,
        event: "service:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_serviceChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_serviceChange_8369],
      }
    );
    const act_5962862420439144_script_8372 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8372_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_quantityChange_8371 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8372,
        event: "quantity:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_quantityChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_quantityChange_8371],
      }
    );
    const act_5962862420439144_script_8374 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8374_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_unitPriceChange_8373 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8374,
        event: "unit_price:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_unitPriceChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_unitPriceChange_8373],
      }
    );
    const act_5962862420439144_script_8376 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8376_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_discountChange_8375 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8376,
        event: "discount:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_discountChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_discountChange_8375],
      }
    );
    const act_5962862420439144_script_8378 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8378_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_netAmountChange_8377 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8378,
        event: "net_amount:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_netAmountChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_netAmountChange_8377],
      }
    );
    const act_5962862420439144_script_8380 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8380_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_amountChange_8379 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8380,
        event: "amount:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_amountChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_amountChange_8379],
      }
    );
    const act_5962862420439144_script_8382 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8382_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_taxCodeChange_8381 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8382,
        event: "tax_code:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_taxCodeChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_taxCodeChange_8381],
      }
    );
    return {
      act_5962862420439144_emit_8362,
      evh_5962862420439144_saveCompleted_8361,
      evh_5962862420439144_saveCompleted,
      act_5962862420439144_script_8364,
      evh_5962862420439144_save_8363,
      evh_5962862420439144_save,
      act_5962862420439144_script_8366,
      evh_5962862420439144_delete_8365,
      evh_5962862420439144_delete,
      act_5962862420439144_script_8368,
      evh_5962862420439144_serviceSelected_8367,
      evh_5962862420439144_serviceSelected,
      act_5962862420439144_script_8370,
      evh_5962862420439144_serviceChange_8369,
      evh_5962862420439144_serviceChange,
      act_5962862420439144_script_8372,
      evh_5962862420439144_quantityChange_8371,
      evh_5962862420439144_quantityChange,
      act_5962862420439144_script_8374,
      evh_5962862420439144_unitPriceChange_8373,
      evh_5962862420439144_unitPriceChange,
      act_5962862420439144_script_8376,
      evh_5962862420439144_discountChange_8375,
      evh_5962862420439144_discountChange,
      act_5962862420439144_script_8378,
      evh_5962862420439144_netAmountChange_8377,
      evh_5962862420439144_netAmountChange,
      act_5962862420439144_script_8380,
      evh_5962862420439144_amountChange_8379,
      evh_5962862420439144_amountChange,
      act_5962862420439144_script_8382,
      evh_5962862420439144_taxCodeChange_8381,
      evh_5962862420439144_taxCodeChange,
    }
  }
}

Vue.component("UcWorksheetWorkItems", UcWorksheetWorkItems);

</script>